export default "__VITE_ASSET__B$cnIRqj__"